import scrollToTop from './scrollToTop.js';

const updateProd = (value, maxValue, prod, step, setSteps, searchParams, setSearchParams, setIsLoading, prevValue, fProducts) => {
    if(prod.compatible === false) return;

    if(value === 0) {
        setIsLoading(true);

        scrollToTop();

        setSteps(prevSteps => prevSteps.map(prevStep => prevStep.id === step.id ? {...prevStep, data: undefined} : prevStep))

        searchParams.delete(step.tag);
        return setSearchParams(searchParams, { replace: true });
    } else if (value === 1) {
        scrollToTop();

        searchParams.set(step.tag, prod.id);
        setSearchParams(searchParams, { replace: true });
    } else {
        let stringParam = prod.id;

        for(let i = 1; i < value; i++) {
            stringParam += `,${prod.id}`;
        }

        searchParams.set(step.tag, stringParam);
        setSearchParams(searchParams, { replace: true });

        if(value === Number(maxValue)) {
            searchParams.set('step', Number(searchParams.get('step')) + 1);
            setSearchParams(searchParams, { replace: true });
        }
    }

    if(prevValue === 0 && fProducts.data[0]?.id !== prod.id) setIsLoading(true);

    setSteps(prevSteps => prevSteps.map(prevStep => prevStep.id === step.id ? {...prevStep, data: {...prod, cantidad: value}} : prevStep))
}

export default updateProd;